module.exports = __webpack_public_path__ + "media/events/2018Show-e8b782bc.jpg";